export default "__VITE_ASSET__DYmffKwV__"